// extracted by mini-css-extract-plugin
module.exports = {"button__color":"success_button__color__ATm21"};